import api from 'api';
import { WEB_API_ROUTES } from 'api/api-routes';
import { createThunk } from '../../utils/storeUtils';

export const thunks = {
  submitCreation: createThunk('createClass/submitCreation', (data) =>
    api.post(WEB_API_ROUTES.classes.list, data)
  ),
};
